// =====================================================
// MING - Minguro Gaming Member App Configuration
// =====================================================

// API Configuration - PRODUCTION
const API_BASE_URL = 'https://mingdigital.site/api';

export const API = {
    AUTH: {
        LOGIN: `${API_BASE_URL}/auth.php?action=login`,
        REGISTER: `${API_BASE_URL}/auth.php?action=register`,
    },
    MEMBER: {
        PROFILE: (memberId) => `${API_BASE_URL}/member.php?action=profile&member_id=${memberId}`,
        STATS: (memberId) => `${API_BASE_URL}/member.php?action=stats&member_id=${memberId}`,
        RIWAYAT_POIN: (memberId) => `${API_BASE_URL}/member.php?action=riwayat_poin&member_id=${memberId}`,
        RIWAYAT_MAIN: (memberId) => `${API_BASE_URL}/member.php?action=riwayat_main&member_id=${memberId}`,
        RIWAYAT_REDEEM: (memberId) => `${API_BASE_URL}/member.php?action=riwayat_redeem&member_id=${memberId}`,
    },
    HADIAH: {
        LIST: `${API_BASE_URL}/hadiah.php?action=list`,
        DETAIL: (id) => `${API_BASE_URL}/hadiah.php?action=detail&id=${id}`,
        REDEEM: `${API_BASE_URL}/hadiah.php?action=redeem`,
        MY_REDEEMED: (memberId) => `${API_BASE_URL}/hadiah.php?action=my_redeemed&member_id=${memberId}`,
    },
    TOPUP: {
        REQUEST: `${API_BASE_URL}/topup.php?action=request`,
        HISTORY: (memberId) => `${API_BASE_URL}/topup.php?action=history&member_id=${memberId}`,
    },
    VOUCHER: {
        LIST: `${API_BASE_URL}/voucher.php?action=list`,
        CLAIM: `${API_BASE_URL}/voucher.php?action=claim`,
        MY_VOUCHERS: (memberId) => `${API_BASE_URL}/voucher.php?action=my_vouchers&member_id=${memberId}`,
    },
    EVENT: {
        LIST: `${API_BASE_URL}/event.php?action=list`,
    },
    CHAT: {
        GET_MESSAGES: (memberId) => `${API_BASE_URL}/chat.php?action=get_messages&member_id=${memberId}`,
        SEND_MESSAGE: (memberId) => `${API_BASE_URL}/chat.php?action=send_message&member_id=${memberId}`,
    },
    UNDIAN: {
        TUKAR: `${API_BASE_URL}/undian.php?action=tukar`,
        LIST: (memberId) => `${API_BASE_URL}/undian.php?action=list&member_id=${memberId}`,
        CURRENT_PERIOD: `${API_BASE_URL}/undian.php?action=current_period`,
    },
    NOTIFICATIONS: {
        LIST: (memberId) => `${API_BASE_URL}/notifications.php?action=list&member_id=${memberId}`,
        MARK_READ: `${API_BASE_URL}/notifications.php?action=mark_read`,
        MARK_ALL_READ: `${API_BASE_URL}/notifications.php?action=mark_all_read`,
        UNREAD_COUNT: (memberId) => `${API_BASE_URL}/notifications.php?action=unread_count&member_id=${memberId}`,
    },
    SETTINGS: {
        ALL: `${API_BASE_URL}/settings.php?action=all`,
        TOPUP: `${API_BASE_URL}/settings.php?action=topup`,
        CONTACT: `${API_BASE_URL}/settings.php?action=contact`,
    },
};

// Export API_URL for screens that need raw URL
export const API_URL = API_BASE_URL;

// =====================================================
// MING THEME - Gaming Red Style
// =====================================================
export const COLORS = {
    // Primary - MING Red (Gaming)
    primary: '#CC0000',    // Merah MING Strong
    primaryDark: '#990000', // Merah Gelap
    primaryLight: '#FF3333', // Merah Terang

    // Secondary - Black/Dark Grey (Esport Contrast)
    secondary: '#1F2937',  // Dark Grey
    accent: '#FFD700',     // Gold accent

    // Status Colors
    success: '#00C853',
    warning: '#FFA000',
    danger: '#D32F2F',
    info: '#2196F3',

    // Background - Clean White with subtle warm tint
    bgDark: '#FCF5F5',     // Very light red tint
    bgDarker: '#FFFFFF',
    bgCard: '#FFFFFF',
    bgCardHover: '#FFF0F0', // Hover merah muda

    // Text
    textPrimary: '#111827',
    textSecondary: '#4B5563',
    textMuted: '#9CA3AF',

    // Border
    border: '#FECACA',      // Merah muda (Tailwind Red-200)
    borderLight: '#FEF2F2', // Merah sangat muda

    // Gaming accents
    neon: '#FF0000',
    gold: '#FFD700',
    football: '#228B22',
};

// App Info
export const APP_INFO = {
    name: 'MING',
    fullName: 'Rental PS Ming',
    currency: 'Reward Poin',
    currencyShort: 'MP',
    version: '2.0.0',
};

// Spending Rate: 1 Rupiah = 1 Reward Poin
export const SPENDING_RATE = 1;
